import { Col, Form, Input, message, Row } from 'antd';
import React from 'react';
import superagent from 'superagent';
import { BACKEND_API_URL } from '../../utils/constants';
import { randomNum } from '../../utils/random';
import { login } from '../../utils/session';
import { withRouter } from '../../utils/router'

class LoginForm extends React.Component {
    formRef = React.createRef();

    state = {
        focusItem: -1,   //保存当前聚焦的input
        code: ''         //验证码
    }

    componentDidMount() {
        this.createCode()
    }

    /**
     * 生成验证码
     */
    createCode = () => {
        const ctx = this.canvas.getContext('2d')
        const chars = [1, 2, 3, 4, 5, 6, 7, 8, 9,
            'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'j', 'k', 'l', 'm', 'n', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
            'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
        let code = ''
        ctx.clearRect(0, 0, 80, 39)
        for (let i = 0; i < 4; i++) {
            const char = chars[randomNum(0, 57)]
            code += char
            ctx.font = randomNum(20, 25) + 'px SimHei'  //设置字体随机大小
            ctx.fillStyle = '#D3D7F7'
            ctx.textBaseline = 'middle'
            ctx.shadowOffsetX = randomNum(-3, 3)
            ctx.shadowOffsetY = randomNum(-3, 3)
            ctx.shadowBlur = randomNum(-3, 3)
            ctx.shadowColor = 'rgba(0, 0, 0, 0.3)'
            let x = 80 / 5 * (i + 1)
            let y = 39 / 2
            let deg = randomNum(-25, 25)
            /**设置旋转角度和坐标原点**/
            ctx.translate(x, y)
            ctx.rotate(deg * Math.PI / 180)
            ctx.fillText(char, 0, 0)
            /**恢复旋转角度和坐标原点**/
            ctx.rotate(-deg * Math.PI / 180)
            ctx.translate(-x, -y)
        }
        this.setState({
            code
        })
    }
    loginSubmit = (values) => {
        this.setState({
            focusItem: -1
        })
        this.loginAsync(values.username, values.password);
    }

    parseQuery(that) {
        const search = that.props.router.location.search.slice(1)
        const pairs = search ? search.split('&') : []
        const params = {}
        for (let i = 0; i < pairs.length; ++i) {
            const [key, value] = pairs[i].split('=')
            params[key] = params[key] || decodeURIComponent(value)
        }
        return params
    }

    loginAsync(username, password) {
        var that = this;
        function callback(error, response) {
            if (!error && (response.statusCode === 401 || response.statusCode === 403)) {
                message.error('系统错误');
            } else if (!error && response.statusCode === 200) {
                const jsonRes = JSON.parse(response.text);
                if (jsonRes.code === 0) {
                    login({
                        "username": username,
                        "nickname": jsonRes.info.nickname,
                        "avatar": jsonRes.info.avatar
                    })

                    let params = that.parseQuery(that)
                    const redirect = params['from'] ? window.decodeURIComponent(params['from']) : '/'
                    console.log(redirect);
                    window.open(redirect, "_self");
                } else {
                    message.error(jsonRes.info);
                }
            } else {
                message.error("网络错误");
            }
        }

        superagent.post(BACKEND_API_URL.USER_LOGIN_URL).send({ 'name': username, 'password': password })
            .withCredentials()
            .set('Accept', 'application/json')
            //.set('Content-Type', 'multipart/form-data')
            .end(callback);
    }

    goBackRegister = () => {
        this.props.switchShowBox('register')
        setTimeout(() => this.formRef.current.resetFields(), 500)
    }

    goBackHome = () => {
        this.props.router.navigate('/')
    }

    render() {
        const { focusItem, code } = this.state

        return (
            <div className={this.props.className}>
                <div style={styles.logo} onClick={this.goBackHome}>
                    <span style={{ lineHeight: "40px", fontSize: "20px" }}>元纹</span>
                </div>
                <h3 className='title'>用户登录</h3>
                <Form onFinish={this.loginSubmit} ref={this.formRef}>
                    <Form.Item
                        name="username"
                        validateFirst={true}
                        rules={[{ required: true, message: '请输入用户名' }]}>
                        <Input
                            onFocus={() => this.setState({ focusItem: 0 })}
                            onBlur={() => this.setState({ focusItem: -1 })}
                            maxLength={16}
                            placeholder='用户名'
                            autoComplete='on'
                            addonBefore={<span className='iconfont icon-User' style={focusItem === 0 ? styles.focus : {}} />} />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        validateFirst={true}
                        rules={[{ required: true, message: '请输入密码' }]}>
                        <Input
                            onFocus={() => this.setState({ focusItem: 1 })}
                            onBlur={() => this.setState({ focusItem: -1 })}
                            type='password'
                            maxLength={16}
                            placeholder='密码'
                            autoComplete='on'
                            addonBefore={<span className='iconfont icon-suo1' style={focusItem === 1 ? styles.focus : {}} />} />
                    </Form.Item>
                    <Form.Item
                        name="verification"
                        validateFirst={true}
                        rules={[
                            { required: true, message: '请输入验证码' },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (code.toUpperCase() !== value.toUpperCase()) {
                                        return Promise.reject(new Error('验证码输入错误'));
                                    } else {
                                        return Promise.resolve();
                                    }
                                },
                            }),
                        ]}>
                        <Row>
                            <Col span={15}>
                                <Input
                                    onFocus={() => this.setState({ focusItem: 2 })}
                                    onBlur={() => this.setState({ focusItem: -1 })}
                                    maxLength={4}
                                    placeholder='验证码'
                                    addonBefore={<span className='iconfont icon-securityCode-b'
                                        style={focusItem === 2 ? styles.focus : {}} />} />
                            </Col>
                            <Col span={9}>
                                <canvas onClick={this.createCode} width="80" height='39' ref={el => this.canvas = el} />
                            </Col>
                        </Row>
                    </Form.Item>
                    <div className='bottom'>
                        <input className='loginBtn' type="submit" value='登录' />
                        <span className='registerBtn' onClick={this.goBackRegister}>注册</span>
                    </div>
                </Form>
                <div className='footer'>
                    <div>亲爱的，欢迎回来！</div>
                </div>
            </div>
        )
    }
}

const styles = {
    focus: {
        // transform: 'scale(0.7)',
        width: '20px',
        opacity: 1
    },
    logo: {
        height: '50px',
        margin: '10px 0 30px 0',
        color: '#ffffff',
        padding: '4px',
        fontWeight: 'bold',
        textAlign: 'center',
        cursor: 'pointer',
        borderBottom: '1px solid #4444ff'
    },
}

export default withRouter(LoginForm)